import { HELP_CENTER_APP_IDENTIFIER } from "@faire/help-center-utils/consts/HELP_CENTER_APP_IDENTIFIER";
import { appIdentifierInterceptorFactory } from "@faire/web--source/common/requests/request-interceptors/appIdentifierInterceptor";
import { e2eAuthHeaderInterceptor } from "@faire/web--source/common/requests/request-interceptors/e2eAuthHeaderInterceptor";
import { e2eTestTokenInterceptor } from "@faire/web--source/common/requests/request-interceptors/e2eTestTokenInterceptor";
import { releaseVersionHeaderInterceptor } from "@faire/web--source/common/requests/request-interceptors/releaseVersionHeaderInterceptor";
import { settingOverridesInterceptor } from "@faire/web--source/common/requests/request-interceptors/settingOverridesInterceptor";
import { timezoneHeaderInterceptor } from "@faire/web--source/common/requests/request-interceptors/timezoneHeaderInterceptor";
import { tokenHeaderInterceptor } from "@faire/web--source/common/requests/request-interceptors/tokenHeaderInterceptor";
import { RequestInterceptor } from "@faire/web-api--source/types";

export const fetchRequestInterceptors: ReadonlyArray<RequestInterceptor> =
  Object.freeze([
    appIdentifierInterceptorFactory(HELP_CENTER_APP_IDENTIFIER),
    settingOverridesInterceptor,
    releaseVersionHeaderInterceptor,
    e2eAuthHeaderInterceptor,
    e2eTestTokenInterceptor,
    timezoneHeaderInterceptor,
    tokenHeaderInterceptor,
  ]);
